export const MIN_NFTS_PER_TX = 1;
export const NFT_PRICE = 0.21;